module.exports = __webpack_public_path__ + "static/media/AvenirNext-Regular.22e6645a.woff2";